module.exports = __webpack_public_path__ + "static/media/tower.941b0db5.svg";